import tailspin from '../elements/tailspin.js';
tailspin.register();
